import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import qs from 'query-string'
import _ from 'lodash'
import moment from 'moment'
import cx from 'classnames'

import AdminLayout from '@/admin/components/AdminLayout/AdminLayout'
import {
  Input,
  Label,
  Link,
  Loader,
  SortablePaginatedSearchTable,
  Toggler,
} from '@/components'
import { CheckboxCustom } from '@/components/form'
import { getMobxArrayValues, hasOwnProperty } from '@/utils/helpers'
import './InstanceExamPage.scss'

const initialPage = { offset: 0, limit: 25 }
const initialFilters = { ...initialPage }

const getProgressText = (progress) => {
  return progress.includes('-')
    ? 'No Progress'
    : progress[0] === 'p'
    ? 'In Progress'
    : 'Completed'
}

const getFilteredByFilterText = (key, filterText, instructors) => {
  if (key === 'progress') {
    return getProgressText(filterText)
  } else if (key === 'instructor') {
    let instructor = instructors.filter(
      ({ instructorId }) => `${instructorId}` === filterText,
    )[0]
    if (!instructor) return `Instructor#${filterText}`
    let { firstName, lastName } = instructor
    let name = `${firstName || ''}`
    if (lastName) {
      name = `${firstName || ''} ${
        (lastName && lastName.substring(0, 1)) || ''
      }.`
    }
    return name
  } else if (key === 'start_date') {
    return `From: ${filterText}`
  } else if (key === 'end_date') {
    return `To: ${filterText}`
  }
  return filterText
}

const __isValidDate = (value) => {
  if (!value || value === '') return true
  return value.match(/^\d{2}\/\d{2}\/\d{4}$/)
}

const attemptStatuses = ['Invalid', 'Ready', 'In Progress', 'Completed']

const AttemptStatusLabel = ({ attemptStatus, passed }) => {
  const attemptStatusLabel = attemptStatuses[attemptStatus]
  return (
    <span className="InstanceExamPage__attempt-status-label">
      <i
        className={cx('fa', {
          'fa-check': attemptStatusLabel === 'Completed' && passed,
          'fa-clock-o': attemptStatusLabel === 'In Progress',
          'fa-minus':
            attemptStatusLabel !== 'Completed' &&
            attemptStatusLabel !== 'In Progress',
          'fa-times': attemptStatusLabel === 'Completed' && !passed,
        })}
      />
    </span>
  )
}

@inject('adminStore', 'analyticsStore', 'uiStore')
@observer
export default class InstanceExamPage extends Component {
  state = {
    activeFilter: null,
    showFilters: false,
  }
  constructor(props) {
    super(props)
    const { adminStore, history, location, match } = this.props
    const { instance } = adminStore
    const { examAnalyticsFilters } = instance
    const { search } = location
    const filters = qs.parse(search)
    let instructor = filters['instructor']
    let progress = filters['progress']
    let start_date = filters['start_date']
    let end_date = filters['end_date']
    if (hasOwnProperty(filters, 'progress')) {
      filters['progress'] = progress.split(',').filter((v) => v && v !== '')
    }
    if (hasOwnProperty(filters, 'instructor')) {
      filters['instructor'] = instructor.split(',').filter((v) => v && v !== '')
    }
    if (hasOwnProperty(filters, 'start_date')) {
      filters['start_date'] = start_date.split(',').filter((v) => v && v !== '')
    }
    if (hasOwnProperty(filters, 'end_date')) {
      filters['end_date'] = end_date.split(',').filter((v) => v && v !== '')
    }
    const updatedFilters = instance.setExamAnalyticsFilters({
      ...initialFilters,
      ...examAnalyticsFilters,
      ...filters,
    })
    const querystring = { ...updatedFilters }
    Object.keys({ ...querystring }).forEach((key) => {
      const filterValue = instance.getExamAnalyticsFilter(key)
      querystring[key] = Array.isArray(filterValue)
        ? filterValue.join(',')
        : filterValue
    })
    history.push(`${match.url}?${qs.stringify(querystring)}`)
  }
  get hasFilters() {
    const { adminStore } = this.props
    const { instance } = adminStore
    const { examAnalyticsFilters } = instance
    let filters = _.omit(
      examAnalyticsFilters,
      Object.keys(initialPage).concat('q'),
    )
    for (var key in filters) {
      if (Array.isArray(filters[key]) && filters[key].length === 0) {
        delete filters[key]
      }
    }
    return !_.isEmpty(_.filter(filters, (f) => f && f.length !== 0))
  }
  get hasLearners() {
    const { adminStore } = this.props
    const { instance } = adminStore
    const { learnersCount } = instance
    return learnersCount > 0
  }
  componentDidMount() {
    const { adminStore, analyticsStore, match, uiStore } = this.props
    const { instance } = adminStore
    const { examAnalyticsFilters: filters, examAnalyticsSort } = instance
    const { params } = match
    const { instanceId } = params
    uiStore.updateTitle('Course Analytics Page')

    this.courseId = instanceId
    analyticsStore
      .loadCourse(
        { courseId: this.courseId, filters: { ...initialPage } },
        true,
      )
      .then(() => {
        analyticsStore.loadLearners(
          {
            courseId: this.courseId,
            filters,
            sorting: examAnalyticsSort,
          },
          true,
        )
      })
  }
  filter = (nextFilters, { clear, skipSearch } = { skipSearch: false }) => {
    const { adminStore, history, match } = this.props
    const { instance } = adminStore
    const filters = instance.setExamAnalyticsFilters(nextFilters, { clear })
    const querystring = { ...filters }
    Object.keys({ ...querystring }).forEach((key) => {
      const filterValue = instance.getExamAnalyticsFilter(key)
      querystring[key] = Array.isArray(filterValue)
        ? filterValue.join(',')
        : filterValue
    })
    history.push(`${match.url}?${qs.stringify(querystring)}`)
    if (skipSearch) return
    this.searchLearners(filters)
  }
  isFilterChecked = (name, value) => {
    const { adminStore } = this.props
    const { instance } = adminStore
    const { examAnalyticsFilters: filters } = instance
    const filter = filters[name]
    if (!filter) return false
    return filter.indexOf(value) !== -1
  }
  onAccordionChange = (activeFilter) => {
    this.setState({ activeFilter })
  }
  onChangeLimit = (limit) => {
    this.filter({ limit })
  }
  onClearFilters = (event) => {
    event.preventDefault()
    this.filter(initialFilters, { clear: true })
  }
  onClearSearchFilter = () => {
    this.filter({ q: '', ...initialPage })
  }
  onFilterChange = (event) => {
    const { adminStore } = this.props
    const { instance } = adminStore
    const { target } = event
    let { checked, name, type, value } = target
    let skipSearch = false

    if (type === 'checkbox') {
      let targetFilter = instance.getExamAnalyticsFilter(name)
      if (!targetFilter) {
        value = [value]
      } else if (!Array.isArray(targetFilter)) {
        value = [value]
      } else if (targetFilter.indexOf(value) === -1) {
        value = [value, ...targetFilter]
      } else {
        value = targetFilter.filter((v) => v !== value)
      }
    } else if (type === 'radio') {
      value = checked ? [value] : null
    } else if (name === 'start_date' || name === 'end_date') {
      if (!__isValidDate(value.trim())) skipSearch = true
      value = value ? [value.trim()] : []
    }

    const filter = { [name]: value }
    this.filter({ ...filter, ...initialPage }, { skipSearch })
  }
  onLearnerClick = (e, courseId, learnerId) => {
    const { history } = this.props
    e.preventDefault()
    history.push(`/admin/courses/${courseId}/analytics/learners/${learnerId}`)
  }

  onPageClick = (pageIndex) => {
    const { adminStore } = this.props
    const { instance } = adminStore
    const limit = instance.getExamAnalyticsFilter('limit')
    this.filter({ offset: pageIndex * limit })
  }
  onToggleFilters = (value) => {
    this.setState({ showFilters: value })
  }
  searchLearners = _.debounce(
    (filters) => {
      const { adminStore, analyticsStore } = this.props
      const { instance } = adminStore
      const { examAnalyticsSortBy, examAnalyticsSortOrientation } = instance
      const sorting = {
        sortBy: examAnalyticsSortBy,
        sortOrientation: examAnalyticsSortOrientation,
      }
      analyticsStore.loadLearners(
        {
          courseId: this.courseId,
          filters,
          sorting,
        },
        true,
      )
    },
    250,
    { leading: true, trailing: true },
  )
  onCancelFilter = (event, filterKey, filterValue) => {
    const { adminStore } = this.props
    const { instance } = adminStore
    const { examAnalyticsFilters: filters } = instance
    event.preventDefault()
    filters[filterKey] = filters[filterKey].filter((f) => f !== filterValue)
    this.filter({ ...filters, ...initialPage })
  }
  onSortTable = (nextSortBy) => {
    const { adminStore } = this.props
    const { instance } = adminStore
    const { examAnalyticsFilters: filters } = instance
    instance.setExamAnalyticsSort(nextSortBy)
    this.filter({ ...filters, offset: 0 })
  }
  stopPropagation = (event) => {
    event.stopPropagation()
  }
  renderSidebar() {
    return this.hasLearners ? (
      <AdminLayout.Sidebar>
        <Toggler
          icon="tasks"
          className="InstanceExamPage__toggler"
          text="Close filter criteria"
          altText="Show filter criteria"
          onChange={this.onToggleFilters}
          isActive={this.state.showFilters}
        >
          <div className="InstanceExamPage__filters">
            {this.renderInstructorFilters()}
            {this.renderDateFilters()}
            {this.renderProgressFilters()}
          </div>
        </Toggler>
      </AdminLayout.Sidebar>
    ) : null
  }
  renderInstructorFilters() {
    const { analyticsStore } = this.props
    const { isLoadingLearners, report } = analyticsStore
    const { instructors } = report || {}
    return (
      <div className="InstanceExamPage__filter">
        <div className="InstanceExamPage__filter-title">Instructors</div>
        <div className="InstanceExamPage__filter-option">
          {(!instructors || !instructors.length) && isLoadingLearners && (
            <Loader />
          )}
          {instructors &&
            !!instructors.length &&
            instructors.map((instructor) => {
              const {
                firstName: instructorFirstName,
                lastName: instructorLastName,
                instructorId,
              } = instructor
              return (
                <CheckboxCustom
                  checked={this.isFilterChecked(
                    'instructor',
                    `${instructorId}`,
                  )}
                  isBlock
                  isRadio
                  key={`InstanceExamPage__filter-option-${instructorId}`}
                  name="instructor"
                  onChange={this.onFilterChange}
                  text={`${instructorFirstName || ''} ${
                    instructorLastName || ''
                  }`}
                  value={`${instructorId}`}
                />
              )
            })}
          {(!instructors || (!instructors.length && !isLoadingLearners)) && (
            <div>
              <p>No available values</p>
            </div>
          )}
        </div>
      </div>
    )
  }
  renderDateFilters() {
    const { adminStore } = this.props
    const { instance } = adminStore
    const { examAnalyticsFilters: filters } = instance
    const today = moment(new Date()).format('MM/DD/YYYY')
    return (
      <div className="InstanceExamPage__filter">
        <div className="InstanceExamPage__filter-title">Date Added</div>
        <div className="InstanceExamPage__filter-option">
          <Label className="InstanceExamPage__filter-option-label" is="true">
            From Date
            <Input
              name="start_date"
              onChange={this.onFilterChange}
              placeholder="MM/DD/YYYY"
              value={(filters['start_date'] && filters['start_date'][0]) || ''}
            />
          </Label>
          {!__isValidDate(
            filters && filters['start_date'] && filters['start_date'][0],
          ) && (
            <span className="InstanceExamPage__filter-option-error">
              * Please format date as MM/DD/YYYY (example: {today})
            </span>
          )}
        </div>
        <div className="InstanceExamPage__filter-option">
          <Label className="InstanceExamPage__filter-option-label" is3="true">
            To Date
            <Input
              name="end_date"
              onChange={this.onFilterChange}
              placeholder="MM/DD/YYYY"
              value={(filters['end_date'] && filters['end_date'][0]) || ''}
            />
          </Label>
          {!__isValidDate(
            filters && filters['end_date'] && filters['end_date'][0],
          ) && (
            <span className="InstanceExamPage__filter-option-error">
              * Please format date as MM/DD/YYYY (example: {today})
            </span>
          )}
        </div>
      </div>
    )
  }
  renderProgressFilters() {
    const { analyticsStore } = this.props
    const { report } = analyticsStore
    const progressFilters =
      report && report.filters
        ? report.filters.filter((filter) => filter.id === 'progress')
        : []
    let sortedProgressFilters = []
    const sortedProgressValues = {
      'no-progress': null,
      progress: null,
      completed: null,
    }
    if (progressFilters[0] && progressFilters[0].values.length) {
      progressFilters[0].values.forEach((progress) => {
        sortedProgressValues[progress.value] = progress
      })
    }
    for (var key in sortedProgressValues) {
      if (sortedProgressValues[key]) {
        sortedProgressFilters.push(sortedProgressValues[key])
      } else {
        sortedProgressFilters.push({ value: key, count: 0 })
      }
    }
    return (
      <div className="InstanceExamPage__filter">
        <div className="InstanceExamPage__filter-title">Progress</div>
        <div className="control is-expanded InstanceExamPage__filter-option">
          {sortedProgressFilters.length ? (
            sortedProgressFilters.map((progress) => (
              <CheckboxCustom
                checked={this.isFilterChecked('progress', progress.value)}
                isBlock
                key={`InstanceExamPage__filter-option-${progress.value}`}
                name="progress"
                onChange={this.onFilterChange}
                text={getProgressText(progress.value)}
                value={progress.value}
              />
            ))
          ) : (
            <div>
              <p>No available values</p>
            </div>
          )}
        </div>
      </div>
    )
  }
  renderFilteredBy() {
    const { adminStore, analyticsStore } = this.props
    const { instance } = adminStore
    const { report } = analyticsStore
    const { examAnalyticsFilters } = instance
    const { instructors } = report || {}
    const filters = _.omit(
      examAnalyticsFilters,
      Object.keys(initialPage).concat('q'),
    )
    const renderedFilters = _.flatten(
      Object.keys(filters).map((key) => {
        return getMobxArrayValues(filters[key]).map((value, index) => {
          const filteredByFilterText = getFilteredByFilterText(
            key,
            value,
            instructors,
          )
          return (
            <div
              className="InstanceExamPage__filtered-by-filter"
              key={`InstanceExamPage__filtered-by-filter-${key}-${index}`}
            >
              {filteredByFilterText}
              <a
                aria-label={`Remove ${key} filter: ${filteredByFilterText}`}
                className="InstanceExamPage__filtered-by-cancel"
                data-filter={`${key};${value}`}
                href="#"
                onClick={(event) => this.onCancelFilter(event, key, value)}
                role="button"
              >
                <i className="fa fa-close" />
              </a>
            </div>
          )
        })
      }),
    )
    return this.hasFilters && renderedFilters.length ? (
      <div className="InstanceExamPage__filtered-by">
        <strong className="InstanceExamPage__filtered-by-label">
          Filtered By:
        </strong>
        <div className="InstanceExamPage__filtered-by-filters">
          {renderedFilters}
          {renderedFilters.length >= 2 ? (
            <a
              className="InstanceExamPage__filtered-by-clear"
              href="#"
              onClick={this.onClearFilters}
              role="button"
            >
              Clear All
            </a>
          ) : null}
        </div>
      </div>
    ) : null
  }
  renderLearnersList() {
    // TODO / NOTE: read match when learner exam analytics is available
    const { adminStore, analyticsStore } = this.props
    const { report, isLoadingLearners } = analyticsStore
    const { courseId } = report
    const { learners: reportLearners, learnersMeta: reportLearnersMeta } =
      report || {}
    const { count: reportLearnersMetaCount } = reportLearnersMeta || {}
    const hasLearnerData = reportLearners && !_.isEmpty(reportLearners)
    const { instance } = adminStore
    const {
      examAnalyticsFilters: filters,
      examAnalyticsSort,
      settings: instanceSettings,
    } = instance
    const { limit, offset } = filters
    const {
      sortBy: examAnalyticsSortBy,
      sortOrientation: examAnalyticsSortOrientation,
    } = examAnalyticsSort
    const { examEndless, examPassCount } = instanceSettings || {}
    const total = reportLearnersMetaCount || 0

    const canHaveMultiplePassedExams = examPassCount > 1 || examEndless
    let headers = [
      { sortBy: 'first_name', headerText: 'Name' },
      { sortBy: 'start_date', headerText: 'Date Added', textAlign: 'center' },
      { sortBy: 'completed', headerText: 'Status', textAlign: 'center' },
      // TODO / NOTE: implement when ready
      // { sortBy: 'completed_at', headerText: 'Completed At', textAlign: 'center' },
      {
        sortBy: 'average_passed_score',
        headerText: canHaveMultiplePassedExams
          ? 'Average Pass Score'
          : 'Pass Score',
        textAlign: 'center',
      },
      {
        sortBy: canHaveMultiplePassedExams
          ? 'passed_attempts_ratio'
          : 'num_attempts',
        headerText: canHaveMultiplePassedExams ? 'Pass / Attempts' : 'Attempts',
        textAlign: 'center',
      },
      {
        sortBy: 'latest_attempt_status',
        headerText: 'Current Attempt',
        textAlign: 'center',
      },
    ]

    return (
      <div className="InstanceExamPage__learners-table-wrapper">
        {!isLoadingLearners && this.renderFilteredBy()}
        <SortablePaginatedSearchTable
          className="InstanceExamPage__learners-table"
          headers={headers}
          id="InstanceExamPageLearnersTable"
          isLoading={isLoadingLearners}
          offset={parseInt(offset || 0)}
          onChangeLimit={this.onChangeLimit}
          onChangeSearch={this.onFilterChange}
          onClearSearch={this.onClearSearchFilter}
          onPageClick={this.onPageClick}
          onSort={this.onSortTable}
          limit={parseInt(limit)}
          rows={
            hasLearnerData
              ? report.learners.map((learner, index) => {
                  const {
                    averagePassedScore,
                    dateAdded,
                    fullName,
                    // TODO / NOTE: implement when learner exam analytics is available
                    id: learnerId,
                    latestAttemptPassed,
                    latestAttemptStatus,
                    numAttempts,
                    numPassed,
                    passed,
                  } = learner

                  const roundedAveragePassedScore =
                    Math.floor(averagePassedScore)

                  const learnerNameCol = (
                    <Link
                      className="InstanceExamPage__learners-table-column"
                      key={`InstanceExamPage__learners-table-name-${index}`}
                      // TODO / NOTE: implement when learner exam analytics is available
                      onClick={this.stopPropagation}
                      to={`/admin/courses/${courseId}/analytics/learners/${learnerId}`}
                    >
                      {fullName.replace(/\b\w/g, (l) => l.toUpperCase())}
                    </Link>
                  )
                  const startDateCol = (
                    <div
                      className="InstanceExamPage__learners-table-column InstanceExamPage__learners-table-column--is-centered"
                      key={`InstanceExamPage__learners-table-start-date-${index}`}
                    >
                      <span>
                        {moment.utc(dateAdded).local().format('M/D/YYYY')}
                      </span>
                    </div>
                  )
                  const passedCol = (
                    <div
                      className="InstanceExamPage__learners-table-column InstanceExamPage__learners-table-column--is-centered"
                      key={`InstanceExamPage__learners-table-column-exam-${index}`}
                    >
                      {passed ? (
                        <i className="fa fa-check"></i>
                      ) : (
                        <i className="fa fa-minus" />
                      )}
                    </div>
                  )
                  const averageScoreCol = (
                    <div
                      className="InstanceExamPage__learners-table-column InstanceExamPage__learners-table-column--is-centered"
                      key={`InstanceExamPage__learners-table-column-score-${index}`}
                    >
                      {numPassed ? (
                        <span
                          className={cx('InstanceExamPage__pill', {
                            'InstanceExamPage__pill--is-at-risk':
                              roundedAveragePassedScore < 50,
                            'InstanceExamPage__pill--is-good':
                              roundedAveragePassedScore >= 50 &&
                              roundedAveragePassedScore < 75,
                            'InstanceExamPage__pill--is-all-star':
                              roundedAveragePassedScore >= 75,
                          })}
                          key={`InstanceExamPage__learners-table-column-score-${index}`}
                        >
                          {`${roundedAveragePassedScore}%`}
                        </span>
                      ) : (
                        <i className="fa fa-minus" />
                      )}
                    </div>
                  )
                  const attemptsRatio = numAttempts && numPassed / numAttempts
                  const attemptsCol = (
                    <div
                      className="InstanceExamPage__learners-table-column InstanceExamPage__learners-table-column--is-centered"
                      key={`InstanceExamPage__learners-table-column-score-${index}`}
                    >
                      <span
                        className={
                          canHaveMultiplePassedExams &&
                          cx(
                            'InstanceExamPage__pill InstanceExamPage__pill--is-width-auto',
                            {
                              'InstanceExamPage__pill--is-at-risk':
                                attemptsRatio && attemptsRatio < 0.5,
                              'InstanceExamPage__pill--is-good':
                                attemptsRatio &&
                                attemptsRatio >= 0.5 &&
                                attemptsRatio < 0.75,
                              'InstanceExamPage__pill--is-all-star':
                                attemptsRatio && attemptsRatio >= 0.75,
                            },
                          )
                        }
                        key={`InstanceExamPage__learners-table-column-score-${index}`}
                      >
                        {canHaveMultiplePassedExams
                          ? `${numPassed} / ${numAttempts}`
                          : numAttempts}
                      </span>
                    </div>
                  )
                  const attemptStatusCol = (
                    <div
                      className="InstanceExamPage__learners-table-column InstanceExamPage__learners-table-column--is-centered"
                      key={`InstanceExamPage__learners-table-column-score-${index}`}
                    >
                      <AttemptStatusLabel
                        attemptStatus={latestAttemptStatus}
                        key={`InstanceExamPage__learners-table-column-score-${index}`}
                        passed={latestAttemptPassed}
                      />
                    </div>
                  )

                  // TODO / NOTE: implement as # passed / # required
                  // const learnerProgressCol = (
                  //   <div
                  //     key={`"InstanceExamPage__learners-table-progress-${index}"`}
                  //   >
                  //     <Progress
                  //       className="InstanceExamPage__learners-table-progress"
                  //       isAriaHidden
                  //       value={
                  //         completion && completion !== 0 ? completion : 0.001
                  //       }
                  //     />
                  //     <span className="InstanceExamPage__learners-table-progress-text">{`${completion}% Progress`}</span>
                  //   </div>
                  // )

                  let items = [
                    learnerNameCol,
                    startDateCol,
                    passedCol,
                    averageScoreCol,
                    attemptsCol,
                    attemptStatusCol,
                  ]
                  return {
                    items: items,
                    // TODO / NOTE: implement when exam analytics is available
                    onRowClick: (e) =>
                      this.onLearnerClick(e, courseId, learnerId),
                  }
                })
              : []
          }
          showingText="Learners"
          searchLabel="Search learners"
          searchLabelPosition="before"
          searchPlaceholder="Search learners..."
          searchTerm={filters.q || ''}
          sortBy={examAnalyticsSortBy}
          sortAscending={examAnalyticsSortOrientation === 'asc'}
          total={total}
        />
        {!isLoadingLearners && !hasLearnerData ? (
          <div className="title InstanceExamPage__learners-table-empty">
            No learners found.
          </div>
        ) : null}
      </div>
    )
  }
  renderMain() {
    return (
      <AdminLayout.Main id="main-content" isFullWidth={!this.hasLearners}>
        {this.hasLearners ? this.renderLearnersList() : null}
        {!this.hasLearners ? this.renderNoLearners() : null}
      </AdminLayout.Main>
    )
  }
  renderNoLearners() {
    return (
      <div className="InstanceExamPage__no-learners">
        <p>You have 0 learners in this course.</p>
        <br />
        <p>
          Once learners start their adaptive journey through the course, this
          tab will house details about their progress. You’ll be able to use
          Fulcrum’s AI to see who is proficient in the material, who is
          Unsatisfactory, and who your All Stars are.
        </p>
      </div>
    )
  }
  render() {
    const { analyticsStore } = this.props
    const { isLoadingCourse, loadingError } = analyticsStore

    if (loadingError) {
      return (
        <AdminLayout.Box>
          <div className="InstanceExamPage__error-loading">{loadingError}</div>
        </AdminLayout.Box>
      )
    }

    if (isLoadingCourse) {
      return (
        <AdminLayout.Box>
          <Loader />
        </AdminLayout.Box>
      )
    }

    return (
      <AdminLayout className="InstanceExamPage">
        {this.renderSidebar()}
        {this.renderMain()}
      </AdminLayout>
    )
  }
}
